module.exports = __webpack_public_path__ + "img/pic_banner_sell@2x.0ee9d000.png";